var css = {"dragContainer":"List-module_dragContainer__wdruZ"};

export { css as default };
